// extracted by mini-css-extract-plugin
module.exports = {"imagePreview":"styles_imagePreview__-LuWX","dropzoneSelectedFiles":"styles_dropzoneSelectedFiles__3mKo7","deleteIcon":"styles_deleteIcon__1qog5","preview":"styles_preview__n7XCO"};